<script lang="ts">
import SuperAdminLayout from "@/layouts/SuperAdminLayout.vue"

export default { layout: SuperAdminLayout }
</script>

<script setup lang="ts">
import { Head, useForm } from "@inertiajs/vue3"

import FlashAlerts from "@/components/FlashAlerts.vue"
import { superAdminUserPath } from "@/routes"

const props = defineProps<{
  user: {
    id: string
    first_name: string
    last_name: string
    email_address: string
    super_admin: boolean
  }
}>()

const form = useForm({
  first_name: props.user.first_name,
  last_name: props.user.last_name,
  email_address: props.user.email_address,
  password: "",
  password_confirmation: "",
  super_admin: props.user.super_admin,
})

function submit() {
  form.patch(superAdminUserPath(props.user.id))
}
</script>

<template>
  <Head :title="`Edit ${user.first_name} — Admin`" />

  <div class="flex flex-col gap-6">
    <FlashAlerts />

    <form class="flex flex-col gap-4" @submit.prevent="submit">
      <UFormField label="First name" :error="form.errors.first_name">
        <UInput v-model="form.first_name" required autofocus maxlength="50" />
      </UFormField>

      <UFormField label="Last name" :error="form.errors.last_name">
        <UInput v-model="form.last_name" required maxlength="100" />
      </UFormField>

      <UFormField label="Email" :error="form.errors.email_address">
        <UInput v-model="form.email_address" type="email" required autocomplete="off" />
      </UFormField>

      <UFormField
        label="Password"
        hint="Leave blank to keep current password"
        :error="form.errors.password"
      >
        <UInput
          v-model="form.password"
          type="password"
          autocomplete="new-password"
          maxlength="72"
        />
      </UFormField>

      <UFormField label="Password confirmation" :error="form.errors.password_confirmation">
        <UInput
          v-model="form.password_confirmation"
          type="password"
          autocomplete="new-password"
          maxlength="72"
        />
      </UFormField>

      <USwitch v-model="form.super_admin" label="Super Admin" />

      <div class="flex gap-4">
        <UButton
          label="Cancel"
          color="neutral"
          variant="outline"
          :to="superAdminUserPath(user.id)"
        />
        <UButton type="submit" label="Save" :loading="form.processing" />
      </div>
    </form>
  </div>
</template>
